import { WZ_ASPECTS, WZ_PLANETS } from "../../../core/constants";

const SUN_SIGN_CUTS = [20, 19, 21, 20, 21, 21, 23, 23, 23, 23, 22, 22];

export function getWesternSunSignIndex(dob) {
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return 0;
  const m = d.getMonth();
  const day = d.getDate();
  return day < SUN_SIGN_CUTS[m] ? (m + 9) % 12 : (m + 10) % 12;
}

export function computeWesternChart(dob) {
  const d = new Date(dob);
  const seed = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  const sunIdx = getWesternSunSignIndex(dob);
  const sunDeg = sunIdx * 30 + (seed % 29);
  const planetDegs = WZ_PLANETS.map((_planet, i) =>
    Math.round((sunDeg + i * 37 + (seed % (40 + i * 7))) % 360)
  );
  const risingIdx = (sunIdx + 3 + (seed % 5)) % 12;
  const moonIdx = (sunIdx + 4 + (seed % 7)) % 12;
  const aspectList = [];

  for (let i = 1; i < WZ_PLANETS.length; i += 1) {
    const diff = Math.abs(planetDegs[0] - planetDegs[i]) % 360;
    const norm = diff > 180 ? 360 - diff : diff;
    const match = WZ_ASPECTS.find((aspect) => Math.abs(norm - aspect.deg) < 12);
    if (match) {
      aspectList.push({ p1: 0, p2: i, ...match, orb: Math.abs(norm - match.deg) });
    }
  }

  return { sunIdx, sunDeg, planetDegs, risingIdx, moonIdx, aspectList, dob };
}
